export enum DriverAssignmentMode {
  INHERITED      = 'INHERITED',
  CMAWEB_AND_CMA = 'CMAWEB_AND_CMA',
  CMAWEB         = 'CMAWEB',
  TMS_ONLY       = 'TMS_ONLY',
}
